/* ================================================================
   CBCR · About Us — Shared JS
   ================================================================
   Moduli isolati per sezione. Ogni elemento viene marcato con
   data-cbcr-init per prevenire doppia inizializzazione quando il
   file viene incluso da più sections nella stessa pagina.
   ================================================================ */

(function () {
  'use strict';

  // ============ § Section 2 · Tab switcher + Mobile carousel ============
  function initTabs() {
    document.querySelectorAll('.cbcr-story').forEach(function (scope) {
      if (scope.dataset.cbcrInit) return;
      scope.dataset.cbcrInit = '1';

      var tabs = scope.querySelectorAll('.cbcr-tab');
      var panels = scope.querySelectorAll('.cbcr-panel');
      var panelsContainer = scope.querySelector('.cbcr-panels');
      var dots = scope.querySelectorAll('.cbcr-story__dot');
      if (!panels.length) return;

      // Desktop: tabs click → switch is-active panel (comportamento classico).
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-target');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
          });
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var list = Array.from(tabs);
          var idx = list.indexOf(tab);
          var next = e.key === 'ArrowRight' ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
          list[next].focus();
          list[next].click();
        });
      });

      // Mobile: carousel singolo. Ogni .cbcr-mpanel = image+text in un blocco.
      // Image+text scrollano insieme nativamente — nessuna sync JS richiesta.
      // CTA is-active sync via IntersectionObserver sul panel dominante.
      var mCarousel = scope.querySelector('.cbcr-mstory__carousel');
      var mPanels = scope.querySelectorAll('.cbcr-mpanel');
      var mCtas = scope.querySelectorAll('.cbcr-mctas');

      if (mCarousel && mPanels.length && 'IntersectionObserver' in window) {
        var setActiveCtas = function (targetPanel) {
          if (!targetPanel) return;
          mCtas.forEach(function (c) {
            c.classList.toggle('is-active', c.getAttribute('data-panel') === targetPanel);
          });
        };
        var ioMobile = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (e) {
            if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
          });
          if (best && best.isIntersecting && best.intersectionRatio > 0.5) {
            setActiveCtas(best.target.getAttribute('data-panel'));
          }
        }, { root: mCarousel, threshold: [0.5, 0.75, 1] });
        mPanels.forEach(function (p) { ioMobile.observe(p); });
      }
    });
  }

  // ============ § Section 3 · Hotspot popover ============
  /* Mobile modal + iPad: sotto 1024px pop diventa modal centrato. */
  var CBCR_HOTSPOT_MOBILE_MQ = '(max-width: 1024px)';

  function isHotspotMobile() {
    return window.matchMedia && window.matchMedia(CBCR_HOTSPOT_MOBILE_MQ).matches;
  }

  function ensureHotspotBackdrop() {
    var bd = document.querySelector('.cbcr-hotspot__backdrop');
    if (bd) return bd;
    bd = document.createElement('div');
    bd.className = 'cbcr-hotspot__backdrop';
    bd.setAttribute('aria-hidden', 'true');
    bd.addEventListener('click', closeAllHotspots);
    document.body.appendChild(bd);
    return bd;
  }

  function closeAllHotspots() {
    document.querySelectorAll('.cbcr-hotspot__dot.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    document.querySelectorAll('.cbcr-hotspot__pop.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    var bd = document.querySelector('.cbcr-hotspot__backdrop.is-open');
    if (bd) bd.classList.remove('is-open');
    document.body.classList.remove('cbcr-hotspot-modal-open');
  }

  function initHotspots() {
    document.querySelectorAll('.cbcr-hotspot__stage').forEach(function (stage) {
      if (stage.dataset.cbcrInit) return;
      stage.dataset.cbcrInit = '1';

      stage.addEventListener('click', function (e) {
        var dot = e.target.closest('.cbcr-hotspot__dot');
        if (!dot) return;
        e.stopPropagation();
        var id = dot.getAttribute('data-hotspot');
        var pop = stage.querySelector('.cbcr-hotspot__pop[data-hotspot="' + id + '"]');
        var wasOpen = dot.classList.contains('is-open');
        closeAllHotspots();
        if (!wasOpen) {
          dot.classList.add('is-open');
          if (pop) pop.classList.add('is-open');
          // Mobile: show backdrop + lock body scroll
          if (isHotspotMobile()) {
            ensureHotspotBackdrop().classList.add('is-open');
            document.body.classList.add('cbcr-hotspot-modal-open');
          }
        }
      });
    });
  }

  // ============ § Section 5 · Before/After slider ============
  function initBeforeAfter() {
    document.querySelectorAll('.cbcr-ba__slider').forEach(function (slider) {
      if (slider.dataset.cbcrInit) return;
      slider.dataset.cbcrInit = '1';

      var after = slider.querySelector('.cbcr-ba__img--after');
      var handle = slider.querySelector('.cbcr-ba__handle');
      if (!after || !handle) return;

      var dragging = false;

      function setPosition(pct) {
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }

      function getPct(clientX) {
        var rect = slider.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      function onMove(clientX) {
        if (!dragging) return;
        setPosition(getPct(clientX));
      }

      slider.addEventListener('mousedown', function (e) {
        dragging = true;
        setPosition(getPct(e.clientX));
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) { onMove(e.clientX); });
      document.addEventListener('mouseup', function () { dragging = false; });

      slider.addEventListener('touchstart', function (e) {
        dragging = true;
        setPosition(getPct(e.touches[0].clientX));
      }, { passive: true });
      slider.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        setPosition(getPct(e.touches[0].clientX));
      }, { passive: true });
      slider.addEventListener('touchend', function () { dragging = false; });

      slider.addEventListener('click', function (e) {
        setPosition(getPct(e.clientX));
      });

      var initial = parseFloat(slider.getAttribute('data-initial-position'));
      if (isNaN(initial)) initial = 50;
      setPosition(initial);
    });
  }

  // ============ § Side nav state machine ============
  window.CBCRAbout = window.CBCRAbout || {};
  var CBCRAbout = window.CBCRAbout;

  CBCRAbout.sideNav = function () {
    var nav = document.querySelector('[data-ab-sidenav]');
    var dot = document.querySelector('.cbcr-about-nav__dot');
    var backdrop = document.querySelector('.cbcr-about-nav__backdrop');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-ab-section]'));
    if (!links.length) return;

    var body = document.body;
    var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1025px)').matches;
    var hero = document.getElementById('about-hero');
    var state = 'in-hero';
    var userOverride = false;
    var leaveTimer = null;

    function setState(s) {
      if (state === s) return;
      state = s;
      body.setAttribute('data-ab-nav-state', s);
      if (dot) dot.setAttribute('aria-expanded', s === 'expanded' ? 'true' : 'false');
    }

    function computeFromScroll() {
      if (userOverride) return;
      var threshold = hero ? hero.offsetHeight - 80 : 500;
      if (window.scrollY > threshold) setState('collapsed');
      else setState('in-hero');
    }

    body.setAttribute('data-ab-nav-state', 'in-hero');

    if (!body.dataset.cbcrAbNavInit) {
      body.dataset.cbcrAbNavInit = '1';

      window.addEventListener('scroll', function () { computeFromScroll(); }, { passive: true });

      if (isDesktop) {
        document.addEventListener('mousemove', function (e) {
          if (state === 'in-hero') return;
          var rightZone = window.innerWidth - 80;
          var centerY = window.innerHeight / 2;
          var inHitZone = e.clientX >= rightZone && Math.abs(e.clientY - centerY) <= 70;
          var inNav = nav && nav.contains(e.target);
          if (inHitZone || inNav) {
            userOverride = true;
            setState('expanded');
            clearTimeout(leaveTimer);
          } else if (state === 'expanded') {
            clearTimeout(leaveTimer);
            leaveTimer = setTimeout(function () {
              userOverride = false;
              computeFromScroll();
            }, 300);
          }
        });
      }

      if (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          if (state === 'expanded') {
            userOverride = false;
            computeFromScroll();
          } else {
            userOverride = true;
            setState('expanded');
          }
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          userOverride = false;
          computeFromScroll();
        });
      }
      document.addEventListener('click', function (e) {
        if (state !== 'expanded') return;
        if (nav.contains(e.target) || (dot && dot.contains(e.target))) return;
        userOverride = false;
        computeFromScroll();
      });
    }

    function updateActive() {
      var mid = window.innerHeight * 0.4;
      var active = null;
      links.forEach(function (a) {
        var id = a.getAttribute('data-ab-section');
        var el = document.getElementById(id);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top < mid && r.bottom > mid) active = a;
      });
      links.forEach(function (a) { a.classList.toggle('is-active', a === active); });
    }
    if (!nav.dataset.cbcrAbActiveInit) {
      nav.dataset.cbcrAbActiveInit = '1';
      window.addEventListener('scroll', updateActive, { passive: true });
    }
    updateActive();

    links.forEach(function (a) {
      if (a.dataset.cbcrAbNavClick) return;
      a.dataset.cbcrAbNavClick = '1';
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-ab-section');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var rect = target.getBoundingClientRect();
        window.scrollTo({ top: rect.top + window.scrollY - 40, behavior: 'smooth' });
        if (state === 'expanded') {
          userOverride = false;
          setTimeout(computeFromScroll, 600);
        }
      });
    });

    computeFromScroll();
  };

  // ============ § Section 11 · Sticky CTA bar ============
  function initSticky() {
    document.querySelectorAll('.cbcr-sticky').forEach(function (bar) {
      if (bar.dataset.cbcrInit) return;
      bar.dataset.cbcrInit = '1';

      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 900;
      var ticking = false;
      var footer = document.querySelector('.footer');

      function check() {
        var pastThreshold = window.scrollY >= threshold;
        var footerVisible = false;
        if (footer) {
          var rect = footer.getBoundingClientRect();
          footerVisible = rect.top <= window.innerHeight;
        }
        if (pastThreshold && !footerVisible) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(check);
          ticking = true;
        }
      }, { passive: true });

      check();
    });
  }

  // ============ Document-level listeners (attached once) ============
  function initDocListeners() {
    if (window.__cbcrAboutDocListeners) return;
    window.__cbcrAboutDocListeners = true;

    document.addEventListener('click', function (e) {
      // X button inside pop → close
      if (e.target.closest('[data-hotspot-close]')) {
        e.stopPropagation();
        closeAllHotspots();
        return;
      }
      // Outside dot + pop → close
      if (!e.target.closest('.cbcr-hotspot__dot') && !e.target.closest('.cbcr-hotspot__pop')) {
        closeAllHotspots();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllHotspots();
    });

    // Close open hotspots on breakpoint cross (avoids broken state on device rotation).
    if (window.matchMedia) {
      var mm = window.matchMedia(CBCR_HOTSPOT_MOBILE_MQ);
      var onChange = function () { closeAllHotspots(); };
      if (mm.addEventListener) mm.addEventListener('change', onChange);
      else if (mm.addListener) mm.addListener(onChange);
    }
  }

  // ============ § Process Cards · touch hover (mobile) ============
  // Su mobile :hover è "sticky" (iOS): primo tap applica hover sticky fino a tap fuori.
  // Qui gestiamo sfioramento: touch muove attraverso card → applica .is-touch-hover
  // in tempo reale; touchend → rimuove. Navigation (<a href>) resta nativa.
  function initPcardTouchHover() {
    if (window.__cbcrPcardTouchInit) return;
    window.__cbcrPcardTouchInit = true;

    // Attiva solo su touch devices (evita conflitti mouse).
    if (!('ontouchstart' in window)) return;

    var currentHover = null;

    function findPcardAt(x, y) {
      var els = document.elementsFromPoint(x, y);
      for (var i = 0; i < els.length; i++) {
        var p = els[i].closest ? els[i].closest('.cbcr-pcard') : null;
        if (p) return p;
      }
      return null;
    }

    function setHover(card) {
      if (card === currentHover) return;
      if (currentHover) currentHover.classList.remove('is-touch-hover');
      if (card) card.classList.add('is-touch-hover');
      currentHover = card;
    }

    function clearHover() {
      if (currentHover) currentHover.classList.remove('is-touch-hover');
      currentHover = null;
    }

    function handleTouch(e) {
      var t = e.touches && e.touches[0];
      if (!t) return;
      setHover(findPcardAt(t.clientX, t.clientY));
    }

    document.addEventListener('touchstart', handleTouch, { passive: true });
    document.addEventListener('touchmove', handleTouch, { passive: true });
    document.addEventListener('touchend', clearHover, { passive: true });
    document.addEventListener('touchcancel', clearHover, { passive: true });
  }

  // ============ Boot ============
  /* Hero parallax: gestito via CSS scroll-driven animation (vedi cbcr-about.css
     `@supports (animation-timeline: scroll())`). Compositor-driven, no JS. */
  function boot() {
    initDocListeners();
    initTabs();
    initHotspots();
    initBeforeAfter();
    initSticky();
    initPcardTouchHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init dopo Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', boot);
})();
